import { useContext, useEffect, useState } from 'react';
import { AppState } from '../context/general';
import { getMode } from './auth';
import { getPlanLimits } from '../schema-copy/userPlans';
import { MAX_ANON_FEEDS } from './feed-engine';

/**
 * Live feed-quota status for the current session. `max` is the anonymous cap (MAX_ANON_FEEDS) for
 * anonymous users, otherwise the logged-in plan's `maxFeeds`. `atLimit` is true once the
 * followed-feed count reaches the max — used to disable Follow buttons and show "max feeds reached"
 * notices/cards.
 */
export function useFeedQuota(): { count: number; max: number; atLimit: boolean } {
  const appState = useContext(AppState);
  const { feedEngine } = appState;
  const [count, setCount] = useState(() => feedEngine.getFeeds().length);
  useEffect(() => {
    const update = () => setCount(feedEngine.getFeeds().length);
    update();
    return feedEngine.onFeedsChange(update);
  }, [feedEngine]);
  const max = getMode() == 'anon'
    ? MAX_ANON_FEEDS
    : getPlanLimits(appState.state.currentUser?.userPlan ?? 'free').maxFeeds;
  return { count, max, atLimit: count >= max };
}
